import React, { useState, useRef, useEffect } from 'react';
import ReactMapGL from 'react-map-gl';
import Geocoder from 'react-map-gl-geocoder';
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { calculateDensities } from './utils';

import liverpoolCadastre from './liverpoolCadastre.geojson';
const mapboxToken =
  'pk.eyJ1IjoiZ2lyYWZmZXRlY2hub2xvZ3kiLCJhIjoiY2pvMG1ndjBoMDJkejNwbngya2VyenpqMyJ9.RyxX4VKzdQd-GfcsVhyKwg';

const MapBox = ({ formData, setFormData }) => {
  const [mapCenter, setMapCenter] = useState({
    latitude: -33.937,
    longitude: 150.787,
    zoom: 12.7
  });

  const mapRef = useRef(null);

  //Update highlight selection
  useEffect(() => {
    const selectedSource = mapRef.current.getMap().getSource('cadastre-fill');
    if (selectedSource !== undefined) {
      selectedSource.setData({
        type: 'FeatureCollection',
        features: formData['Location']['Selected Lots']
      });
    }
  });

  const handleMapLoad = evt => {
    const map = evt.target;
    // Add click layer
    map.addSource('cadastre-click', {
      type: 'geojson',
      data: liverpoolCadastre
    });
    map.addLayer({
      id: 'cadastre-click',
      type: 'fill',
      source: 'cadastre-click',
      paint: {
        'fill-opacity': 0
      }
    });
    // Add fill layer
    map.addSource('cadastre-fill', {
      type: 'geojson',
      data: { type: 'FeatureCollection', features: [] }
    });
    map.addLayer({
      id: 'cadastre-fill',
      type: 'fill',
      source: 'cadastre-fill',
      paint: {
        'fill-color': 'DARKSLATEBLUE',
        'fill-opacity': 0.4
      }
    });
  };

  const handleMapClick = evt => {
    // ignore clicks on geocode
    if (evt.target.className === 'mapboxgl-ctrl-geocoder--input') return;
    const clickedSite = evt.features.filter(
      f => f.layer.id === 'cadastre-click'
    )[0];
    if (clickedSite !== undefined) {
      const feature = clickedSite.toJSON();
      const selectedLots = formData['Location']['Selected Lots'];
      //Add site, or remove if it's already in selection
      // TODO use removeLot from App.js
      let newSelection;
      if (
        selectedLots.filter(
          s => s.properties.GlobalID === feature.properties.GlobalID
        ).length === 0
      ) {
        newSelection = [...selectedLots, feature];
      } else {
        newSelection = selectedLots.filter(
          s => s.properties.GlobalID !== feature.properties.GlobalID
        );
      }
      
      const densityAreas = calculateDensities(newSelection);
      //Update state
      setFormData({
        ...formData,
        'Location': {
          ...formData['Location'],
          'Selected Lots': newSelection
        },
        'Dwelling density': {
          ...formData['Dwelling density'],
          'Area of land in Very Low Density Residential (10 dw/ha)':
            densityAreas['10'],
          'Area of land in Lower Density Residential (15 dw/ha)':
            densityAreas['15'],
          'Area of land in Low Density Residential (20 dw/ha)':
            densityAreas['20'],
          'Area of land in R3 Medium Density Residential (25 dw/ha)':
            densityAreas['25']
        }
      });
    }
  };

  const handleViewportChange = viewport => {
    setMapCenter(viewport);
  };

  // if you are happy with Geocoder default settings, you can just use handleViewportChange directly
  const handleGeocoderViewportChange = viewport => {
    const geocoderDefaultOverrides = { transitionDuration: 1000 };
    return handleViewportChange({
      ...viewport,
      ...geocoderDefaultOverrides
    });
  };

  const handleOnResult = event => {
    console.log(event.result);
  };

  return (
    <ReactMapGL
      ref={mapRef}
      {...mapCenter}
      width={window.innerWidth}
      height={window.innerHeight}
      mapboxApiAccessToken={mapboxToken}
      mapStyle={'mapbox://styles/giraffetechnology/ck2zr6ecs0b2g1cmnugz9hvg8'}
      onLoad={handleMapLoad}
      onClick={handleMapClick}
      onViewportChange={viewport => setMapCenter(viewport)}
      getCursor={() => 'default'}
      maxZoom={18}
      touchRotate={true}
    >
      <Geocoder
        mapRef={mapRef}
        onResult={handleOnResult}
        onViewportChange={handleGeocoderViewportChange}
        mapboxApiAccessToken={mapboxToken}
        position='top-right'
        proximity={{ latitude: -33.937, longitude: 150.787 }}
        zoom={16}
      />
    </ReactMapGL>
  );
};

export default MapBox;
